<template lang="pug">
  //- 新版电商返佣
  CommonLoadBox(:loaded="rakeBackloaded")
    template(slot='skeleton')
      RakeBackSkeleton
    template(slot='module')
      CashbackPurchase(
        ref="cashbackPurchaseRef"
        :rakeBackModuleInfo="rakeBackModuleInfo"
        @bounty="handleBountyRefresh"
        @loaded="handleLoaded"
      )
</template>

<script>
import CommonLoadBox from '@/components/common-load-box';
import SPM from '../common/spm';
import CashbackPurchase from './cashback-purchase';
import MallReward from '../components/mall-reward';
import RakeBackSkeleton from '../skeleton-cpns/rake-back-skeleton';

export default {
  name: 'RakeBack',
  components: {
    CashbackPurchase,
    MallReward,
    CommonLoadBox,
    RakeBackSkeleton,
  },
  props: {
    // 电商返佣模块信息
    rakeBackModuleInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      readClipboardTimer: null,
      rakeBackloaded: false,
    };
  },
  inject: ['rakeSceneAb', 'pageStatus'],
  computed: {
    // 页面状态
    pageStatusType() {
      if (!this.pageStatus) return '';
      return this.pageStatus();
    },
  },
  watch: {
    // 页面状态变化
    pageStatusType(val) {
      const { cashbackPurchaseRef } = this.$refs || {};
      if (this.readClipboardTimer) {
        clearTimeout(this.readClipboardTimer);
      }

      if (
        val === 'SUCCESS'
        && cashbackPurchaseRef
        && cashbackPurchaseRef.readClipboard
      ) {
        this.readClipboardTimer = setTimeout(() => {
          cashbackPurchaseRef.readClipboard();
        }, 500);
      }
    },
  },
  mounted() {
    // 电商返佣模块曝光
    SPM.moduleExpose({
      moduleId: 'Welfare_onlineretailers',
      contentId: 'Welfare_onlineretailers',
      businessInfo: {},
    });
  },
  destroyed() {
    // 销毁定时器
    if (this.readClipboardTimer) {
      clearTimeout(this.readClipboardTimer);
    }
  },
  methods: {
    // 激励金刷新
    handleBountyRefresh() {
      this.$emit('bounty');
    },
    // 电商返佣模块加载完成
    handleLoaded() {
      this.rakeBackloaded = true;
    },
  },
};
</script>
